/**
 * Mapping erreurs métier U2107 — pure (sans I/O).
 * Garantit que genericErrors est initialisé avant push.
 */
import type { TranslateFn, U2000ApiErrorResult } from '../../u2000Core/axios/U2000HandleApiError';

export function u2107ApplyCategoryBusinessError(
  t: TranslateFn,
  nameSpace: string,
  errorCode: string | undefined,
  errorResult: U2000ApiErrorResult,
): U2000ApiErrorResult {
  if (!errorResult.genericErrors) {
    errorResult.genericErrors = [];
  }
  if (!errorResult.fieldErrors) {
    errorResult.fieldErrors = {};
  }
  switch (errorCode) {
    case 'BU210701':
      errorResult.genericErrors.push({
        title: t('errorTitle', { ns: nameSpace }),
        text: t('errCategoryStillReferenced', { ns: nameSpace }),
      });
      break;
    case 'BU210702':
      errorResult.fieldErrors['code'] = t('errCategoryCodeDuplicate', { ns: nameSpace });
      break;
    case 'BU210703':
      errorResult.fieldErrors['code'] = t('errCategoryCodeImmutable', { ns: nameSpace });
      break;
    default:
      break;
  }
  return errorResult;
}
